/**
 * @licence Copyright © 2019 Mercury Redstone BV, all rights reserved
 */
import styled from 'styled-components';
import { Paper } from '@mui/material';

export const AppPageContentWrapper = styled(Paper)`
  display: flex;
  flex-direction: column;
  padding: 37px 42px 30px;

  ${({ theme }) => theme.breakpoints.down('sm')} {
    padding: 30px 22px 22px;
  }
`;
